import { Monitor, Lightbulb, Code2, Cpu } from "lucide-react";
import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";

const services = [
  {
    icon: Monitor,
    title: "IT Support",
    desc: "System maintenance, troubleshooting, and ongoing technical support to keep your operations running smoothly.",
  },
  {
    icon: Lightbulb,
    title: "Technology Consulting",
    desc: "Infrastructure planning and optimization for business operations — from cloud to on-premise.",
  },
  {
    icon: Code2,
    title: "Software Development",
    desc: "Custom web platforms, internal tools, and integrations built to fit your exact workflow.",
  },
  {
    icon: Cpu,
    title: "IoT Hardware & Automation",
    desc: "Device prototyping, firmware, and workflow automation using agents and task flows.",
  },
];

const Services = () => {
  const headingRef = useScrollReveal();
  const gridRef = useStaggerReveal(100);

  return (
    <section id="services" className="bg-card py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-6">
        <div ref={headingRef} className="mx-auto max-w-2xl text-center" data-reveal>
          <h2
            className="text-3xl font-bold tracking-tight text-foreground md:text-4xl"
            style={{ textWrap: "balance" }}
          >
            What We Do
          </h2>
          <p className="mt-4 text-muted-foreground" style={{ textWrap: "pretty" }}>
            End-to-end technology services designed to help your business move faster and operate more efficiently.
          </p>
        </div>

        <div ref={gridRef} className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((s) => (
            <div
              key={s.title}
              data-reveal
              className="group rounded-card border border-border bg-background p-6 shadow-sm transition-shadow duration-200 hover:shadow-md"
            >
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-accent/10 text-accent transition-colors group-hover:bg-accent/15">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="text-base font-semibold text-foreground">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
